export default __webpack_public_path__ + "static/media/rashmika.75227409.webp";